/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Case_History_Headline_Case_UpdatedInputs */

const en_case_history_headline_case_updated = /** @type {(inputs: Case_History_Headline_Case_UpdatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Case updated`)
};

const pt_br2_case_history_headline_case_updated = /** @type {(inputs: Case_History_Headline_Case_UpdatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Caso atualizado`)
};

/**
* | output |
* | --- |
* | "Case updated" |
*
* @param {Case_History_Headline_Case_UpdatedInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_history_headline_case_updated = /** @type {((inputs?: Case_History_Headline_Case_UpdatedInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_History_Headline_Case_UpdatedInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_history_headline_case_updated(inputs)
	return pt_br2_case_history_headline_case_updated(inputs)
});